import { z } from 'zod';
import { Address } from '../address';
import { Company } from '../companies';
import { ContactDetails } from '../contact';
import { FinanceModel, PeripheralFinanceModel } from '../financemodels';
import { Product } from './types';

const BundledItem = z.object({
  catalogItem: z.string(),
  count: z.number()
});

export type BundledItem = z.infer<typeof BundledItem>;

export const Bundle = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  code: z.string(),
  mainDevice: z.string(),
  bundledItems: z.array(BundledItem)
});

export type Bundle = z.infer<typeof Bundle>;

export enum PurchaseOrderDeliveryOption {
  Daas,
  Msp,
  Custom
}

export const PurchaseOrderBundle = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string(),
  company: Company,
  bundledItems: z.array(BundledItem),
  address: Address.optional(),
  contactDetail: ContactDetails.optional(),
  deliveryOption: z.nativeEnum(PurchaseOrderDeliveryOption),
  poReference: z.string().optional(),
  stockingOrderNumber: z.string().optional(),
  partnerReference: z.string().optional(),
  financeModels: z.array(FinanceModel).optional(),
  state: z.number(),
  peripheralFinanceModel: PeripheralFinanceModel.optional(),
  createdOn: z.string(),
  updatedOn: z.string(),
  submittedOn: z.string(),
  deviceFeeCatalogItem: Product.optional(),
  notes: z.any()
});

export type PurchaseOrderBundle = z.infer<typeof PurchaseOrderBundle>;

export const PurchaseOrderBundleRequest = z.object({
  name: z.string(),
  code: z.string(),
  bundledItems: z.array(BundledItem),
  addressId: z.string().optional(),
  contactDetailId: z.string().optional(),
  deliveryOption: z.nativeEnum(PurchaseOrderDeliveryOption),
  poReference: z.string().optional(),
  stockingOrderNumber: z.string().optional(),
  partnerReference: z.string().optional(),
  financeModelIds: z.array(z.string()).optional(),
  peripheralFinanceModelId: z.string().optional(),
  deviceFeeCatalogItemId: z.string().optional(),
  notes: z.any()
});

export type PurchaseOrderBundleRequest = z.infer<typeof PurchaseOrderBundleRequest>;
